//Art
import Oso from "../assets/groups/Art/Oso+.png";
import Rinoceronte from "../assets/groups/Art/Rinoceronte.png";
import Sculpture1 from "../assets/groups/Art/Sculpture 01.png";

//Extras
import BikeStand01 from "../assets/groups/Extras/Bike stand 01.png";
import BikeStand02 from "../assets/groups/Extras/Bike stand 02.png";
import BikeStand03 from "../assets/groups/Extras/Bike stand 03.png";
import Bollards01 from "../assets/groups/Extras/Bollards 01.png";
import Cafe03 from "../assets/groups/Extras/Cafe 03.png";
import Cafe04 from "../assets/groups/Extras/Cafe 04.png";
import Sink01 from "../assets/groups/Extras/Sink 01.png";
import Sink02 from "../assets/groups/Extras/Sink 02.png";

//Lights
import Lamp01 from "../assets/groups/Lights/Lamp 01.png";
import Lamp02 from "../assets/groups/Lights/Lamp 02.png";
import Lamp03 from "../assets/groups/Lights/Lamp 03.png";
import Lamp04 from "../assets/groups/Lights/Lamp 4.png";
import Lamp05 from "../assets/groups/Lights/Lamp 5.png";
import Lamp06 from "../assets/groups/Lights/Lamp 6.png";
import Lamp07 from "../assets/groups/Lights/Lamp 7.png";
import Lamp08 from "../assets/groups/Lights/Lamp 8.png";
import LightBulbs from "../assets/groups/Lights/Light Bulbs.png";

//Patterns
import ConcreteBlocksTexture from "../assets/groups/Patterns/Concrete Blocks - Texture.jpg";
import ConcreteBlockspattern from "../assets/groups/Patterns/Concrete Blocks - pattern.jpg";
import ConcreteGrasspattern from "../assets/groups/Patterns/Concrete Grass - pattern.jpg";
import ConcreteGrasstexture from "../assets/groups/Patterns/Concrete Grass - texture.jpg";
import GraniteTilespattern from "../assets/groups/Patterns/Granite Tiles -  pattern.jpg";
import GraniteTilesTexture from "../assets/groups/Patterns/Granite Tiles -Texture.jpg";
import PortugueseStoneTexture from "../assets/groups/Patterns/Portuguese Stone - Texture.jpg";
import PortugueseStoneWhitepattern from "../assets/groups/Patterns/Portuguese Stone - White - pattern.jpg";
import PortugueseStoneWhiteTexture from "../assets/groups/Patterns/Portuguese Stone - White Texture.jpg";
import PortugueseStonepattern from "../assets/groups/Patterns/Portuguese Stone - pattern.jpg";
import PortugueseStonePTexturePack from "../assets/groups/Patterns/Portuguese Stone P - Texture Pack.jpg";
import PortugueseStonePpattern from "../assets/groups/Patterns/Portuguese Stone P - pattern.jpg";

//People
import Girl from "../assets/groups/People/Girl.png";
import Boy01 from "../assets/groups/People/Boy 01.png";
import Boy02 from "../assets/groups/People/Boy 02.png";
import Boy03 from "../assets/groups/People/Boy 03.png";
import Boy04 from "../assets/groups/People/Boy 04.png";
import Boy05 from "../assets/groups/People/Boy 05.png";
import Boy06 from "../assets/groups/People/Boy 06.png";
import Cat01 from "../assets/groups/People/Cat 01.png";
import Cat02 from "../assets/groups/People/Cat 02.png";
import Couple01 from "../assets/groups/People/Couple 01.png";
import Couple02 from "../assets/groups/People/Couple 02.png";
import Couple03 from "../assets/groups/People/Couple 03.png";
import Couple04 from "../assets/groups/People/Couple 04.png";
import Couple05 from "../assets/groups/People/Couple 05.png";
import Couple06 from "../assets/groups/People/Couple 06.png";
import Couple07 from "../assets/groups/People/Couple 07.png";
import Couple08 from "../assets/groups/People/Couple 08.png";
import Couple09 from "../assets/groups/People/Couple 09.png";
import Dog01 from "../assets/groups/People/Dog 01.png";
import Dog02 from "../assets/groups/People/Dog 02.png";
import Girl01 from "../assets/groups/People/Girl 01 S.png";
import Girl02 from "../assets/groups/People/Girl 02.png";
import Girl03 from "../assets/groups/People/Girl 03.png";
import Girl04 from "../assets/groups/People/Girl 04.png";
import Group01 from "../assets/groups/People/Group 01.png";
import Group02 from "../assets/groups/People/Group 02.png";
import Group03 from "../assets/groups/People/Group 03.png";
import Group04 from "../assets/groups/People/Group 04.png";
import Group05 from "../assets/groups/People/Group 05.png";
import Lady01 from "../assets/groups/People/Lady 01.png";
import Lady02 from "../assets/groups/People/Lady 02.png";
import Lady03 from "../assets/groups/People/Lady 03.png";
import Lady04 from "../assets/groups/People/Lady 04.png";
import Lady05 from "../assets/groups/People/Lady 05.png";
import Lady06 from "../assets/groups/People/Lady 06.png";
import Lady07 from "../assets/groups/People/Lady 07.png";
import Lady08 from "../assets/groups/People/Lady 08.png";
import Lady09 from "../assets/groups/People/Lady 09.png";
import Lady10 from "../assets/groups/People/Lady 10.png";
import Lady11 from "../assets/groups/People/Lady 11.png";
import Lady12 from "../assets/groups/People/Lady 12.png";
import Lady13 from "../assets/groups/People/Lady 13.png";
import Man01 from "../assets/groups/People/Man 01.png";
import Man02 from "../assets/groups/People/Man 02.png";
import Man03 from "../assets/groups/People/Man 03.png";
import Man04 from "../assets/groups/People/Man 04.png";
import Man05 from "../assets/groups/People/Man 05.png";
import Man06 from "../assets/groups/People/Man 06.png";
import Man07 from "../assets/groups/People/Man 07.png";
import Man08 from "../assets/groups/People/Man 08.png";
import Man09 from "../assets/groups/People/Man 09.png";
import Man10 from "../assets/groups/People/Man 10.png";
import Man11 from "../assets/groups/People/Man 11.png";
import Man12 from "../assets/groups/People/Man 12.png";
import Music01 from "../assets/groups/People/Music 01.png";
import Music02 from "../assets/groups/People/Music 02.png";
import Music03 from "../assets/groups/People/Music 03.png";
import Music04 from "../assets/groups/People/Music 04.png";
import Music05 from "../assets/groups/People/Music 05.png";
import Music06 from "../assets/groups/People/Music 06.png";
import Music07 from "../assets/groups/People/Music 07.png";
import Parent01 from "../assets/groups/People/Parent 01.png";
import Parent02 from "../assets/groups/People/Parent 02.png";
import Parent03 from "../assets/groups/People/Parent 03.png";

//Sports
import Chess01 from "../assets/groups/Sports/Chess 01.png";
import Climbing01 from "../assets/groups/Sports/Climbing 01.png";
import ETEChess01 from "../assets/groups/Sports/ETE Chess 01.png";
import ETETable01 from "../assets/groups/Sports/ETE Table 01.png";
import ETETable02 from "../assets/groups/Sports/ETE Table 02.png";
import DambisLogo from "../assets/groups/Sports/Dambis-logo.png";
import ETETable05 from "../assets/groups/Sports/ETE Table 05.png";
import ETETable06 from "../assets/groups/Sports/ETE Table 06.png";
import ETETable07 from "../assets/groups/Sports/ETE Table 07.png";
import Fitness01 from "../assets/groups/Sports/Fitness 01.png";
import ETELogo from "../assets/groups/Sports/ETE-logo.png";
import Fitness02 from "../assets/groups/Sports/Fitness 02.png";
import Fitness03 from "../assets/groups/Sports/Fitness 03.png";
import Fitness04 from "../assets/groups/Sports/Fitness 04.png";
import Fitness05 from "../assets/groups/Sports/Fitness 05.png";
import Fitness06 from "../assets/groups/Sports/Fitness 06.png";
import Fitness07 from "../assets/groups/Sports/Fitness 07.png";
import Fitness08 from "../assets/groups/Sports/Fitness 08.png";
import Playground01 from "../assets/groups/Sports/Playground 01.png";
import Playground02 from "../assets/groups/Sports/Playground 02.png";
import Sandbox01 from "../assets/groups/Sports/Sandbox 01.png";
import Swing01 from "../assets/groups/Sports/Swing 01.png";
import Swing02 from "../assets/groups/Sports/Swing 02.png";
import Swing03 from "../assets/groups/Sports/Swing 03.png";
import Swing04 from "../assets/groups/Sports/Swing 04.png";
import Swing05 from "../assets/groups/Sports/Swing 05.png";
import Table01 from "../assets/groups/Sports/Table 01.png";

//UrbanFurniture
import Recyclebin01 from "../assets/groups/UrbanFurniture/01 Recycle bin.png";
import Recyclebin02 from "../assets/groups/UrbanFurniture/02 Recycle bin.png";
import Recyclebin05 from "../assets/groups/UrbanFurniture/05 Recycle bin.png";
import Bench01front from "../assets/groups/UrbanFurniture/Bench 01 front.png";
import Bench01 from "../assets/groups/UrbanFurniture/Bench 01.png";
import Bench02semi2 from "../assets/groups/UrbanFurniture/Bench 02 semi 2.png";
import Bench022semi from "../assets/groups/UrbanFurniture/Bench 02 semi.png";
import Bench02 from "../assets/groups/UrbanFurniture/Bench 02.png";
import Bench03 from "../assets/groups/UrbanFurniture/Bench 03.png";
import Bench04 from "../assets/groups/UrbanFurniture/Bench 04.png";
import Bench05 from "../assets/groups/UrbanFurniture/Bench 05.png";
import Cafe01 from "../assets/groups/UrbanFurniture/Cafe 01.png";
import Cafe02 from "../assets/groups/UrbanFurniture/Cafe 02.png";
import Cafe05 from "../assets/groups/UrbanFurniture/Cafe 05.png";
import Cafe06 from "../assets/groups/UrbanFurniture/Cafe 06.png";
import Cafe07 from "../assets/groups/UrbanFurniture/Cafe 07.png";
import ETEBench01 from "../assets/groups/UrbanFurniture/ETE Bench 01.png";
import ETEBench02 from "../assets/groups/UrbanFurniture/ETE Bench 02.png";
import ETEBench03 from "../assets/groups/UrbanFurniture/ETE Bench 03.png";
import ETEBench04 from "../assets/groups/UrbanFurniture/ETE Bench 04.png";
import ETEBench05 from "../assets/groups/UrbanFurniture/ETE Bench 05.png";
import ETEBench06 from "../assets/groups/UrbanFurniture/ETE Bench 06.png";
import ETELiege01 from "../assets/groups/UrbanFurniture/ETE Liege 01.png";
import ETELiege02 from "../assets/groups/UrbanFurniture/ETE Liege 02.png";
import ETELiege03 from "../assets/groups/UrbanFurniture/ETE Liege 03.png";
import ETETable03 from "../assets/groups/UrbanFurniture/ETE Table 03.png";
import Recycletriset01 from "../assets/groups/UrbanFurniture/Recycle triset 01.png";
import TartuBench01 from "../assets/groups/UrbanFurniture/Tartu Bench 01.png";
import TartuBench02 from "../assets/groups/UrbanFurniture/Tartu Bench 02.png";
import TartuBench03 from "../assets/groups/UrbanFurniture/Tartu Bench 03.png";

//UrbanGreenEco
import Flowers01 from "../assets/groups/UrbanGreenEco/Flowers 01.png";
import Grass01 from "../assets/groups/UrbanGreenEco/Grass 01.png";
import Grass02 from "../assets/groups/UrbanGreenEco/Grass 02.png";
import Grass03 from "../assets/groups/UrbanGreenEco/Grass 03.png";
import Grass04 from "../assets/groups/UrbanGreenEco/Grass 04.png";
import Grass05 from "../assets/groups/UrbanGreenEco/Grass 05.png";
import Green01 from "../assets/groups/UrbanGreenEco/Green 01.png";
import Green02 from "../assets/groups/UrbanGreenEco/Green 02.png";
import Green03 from "../assets/groups/UrbanGreenEco/Green 03.png";
import Green04 from "../assets/groups/UrbanGreenEco/Green 04.png";
import Green05 from "../assets/groups/UrbanGreenEco/Green 05.png";
import Green06 from "../assets/groups/UrbanGreenEco/Green 06.png";
import Green07 from "../assets/groups/UrbanGreenEco/Green 07.png";
import Green031 from "../assets/groups/UrbanGreenEco/Green 031.png";
import Green041 from "../assets/groups/UrbanGreenEco/Green 041.png";
import Tree01 from "../assets/groups/UrbanGreenEco/Tree 01.png";
import Tree02 from "../assets/groups/UrbanGreenEco/Tree 02.png";
import Tree03 from "../assets/groups/UrbanGreenEco/Tree 03.png";
import Tree04 from "../assets/groups/UrbanGreenEco/Tree 04.png";
import Tree06 from "../assets/groups/UrbanGreenEco/Tree 06.png";
import Tree07 from "../assets/groups/UrbanGreenEco/Tree 07.png";
import Tree08 from "../assets/groups/UrbanGreenEco/Tree 08.png";
import Tree09 from "../assets/groups/UrbanGreenEco/Tree 09.png";
import Treepot02 from "../assets/groups/UrbanGreenEco/Tree pot 02.png";
import Treepot03 from "../assets/groups/UrbanGreenEco/Tree pot 03.png";
import Treepot04 from "../assets/groups/UrbanGreenEco/Tree pot 04.png";
import Treepot05 from "../assets/groups/UrbanGreenEco/Tree pot 05.png";
import tree from "../assets/groups/UrbanGreenEco/tree.png";

//EventSeat
import Bench012front from "../assets/groups/EventSeat/Bench 01 front.png";
import Bench022semi2 from "../assets/groups/EventSeat/Bench 02 semi 2.png";
import Bench02semi from "../assets/groups/EventSeat/Bench 02 semi.png";
import Cafe011 from "../assets/groups/EventSeat/Cafe 01.png";
import Cafe022 from "../assets/groups/EventSeat/Cafe 02.png";
import Cafe055 from "../assets/groups/EventSeat/Cafe 05.png";
import Cafe066 from "../assets/groups/EventSeat/Cafe 06.png";
import Cafe077 from "../assets/groups/EventSeat/Cafe 07.png";
import TartuBench011 from "../assets/groups/EventSeat/Tartu Bench 01.png";
import TartuBench022 from "../assets/groups/EventSeat/Tartu Bench 02.png";
import TartuBench033 from "../assets/groups/EventSeat/Tartu Bench 03.png";
import Recyclebin001 from "../assets/groups/EventSeat/01 Recycle bin.png";
import Recyclebin002 from "../assets/groups/EventSeat/02 Recycle bin.png";
import Recyclebin005 from "../assets/groups/EventSeat/05 Recycle bin.png";
import Bench011 from "../assets/groups/EventSeat/Bench 01.png";
import Bench012 from "../assets/groups/EventSeat/Bench 02.png";
import Bench013 from "../assets/groups/EventSeat/Bench 03.png";
import Bench014 from "../assets/groups/EventSeat/Bench 04.png";
import Bench015 from "../assets/groups/EventSeat/Bench 05.png";
import Recycletriset011 from "../assets/groups/EventSeat/Recycle triset 01.png";
import ETEBench011 from "../assets/groups/EventSeat/ETE Bench 01.png";
import ETEBench012 from "../assets/groups/EventSeat/ETE Bench 02.png";
import ETEBench013 from "../assets/groups/EventSeat/ETE Bench 03.png";
import ETEBench014 from "../assets/groups/EventSeat/ETE Bench 04.png";
import ETEBench015 from "../assets/groups/EventSeat/ETE Bench 05.png";
import ETEBench016 from "../assets/groups/EventSeat/ETE Bench 06.png";
import ETELiege011 from "../assets/groups/EventSeat/ETE Liege 01.png";
import ETELiege012 from "../assets/groups/EventSeat/ETE Liege 02.png";
import ETELiege013 from "../assets/groups/EventSeat/ETE Liege 03.png";
import ETETable013 from "../assets/groups/EventSeat/ETE Table 03.png";

export const Art = [
  {
    name: "Oso",
    image: Oso,
    isDraggable: true
  },
  {
    name: "Rinoceronte",
    image: Rinoceronte,
    isDraggable: true
  },
  {
    name: "Sculpture",
    image: Sculpture1,
    isDraggable: true
  }
];

export const Extras = [
  {
    name: "BikeStand01",
    image: BikeStand01,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "BikeStand02",
    image: BikeStand02,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "BikeStand03",
    image: BikeStand03,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Bollards01",
    image: Bollards01,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Sink01",
    image: Sink01,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Sink02",
    image: Sink02,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "DambisLogo",
    image: DambisLogo,
    isDraggable: false,
    link: "https://www.dambis.ee/"
  },
  {
    name: "Cafe03",
    image: Cafe03,
    isDraggable: true
  },
  {
    name: "Cafe04",
    image: Cafe04,
    isDraggable: true
  },
];

export const Lights = [
  {
    name: "Lamp01",
    image: Lamp01,
    isDraggable: true
  },
  {
    name: "Lamp02",
    image: Lamp02,
    isDraggable: true
  },
  {
    name: "Lamp03",
    image: Lamp03,
    isDraggable: true
  },
  {
    name: "Lamp04",
    image: Lamp04,
    isDraggable: true
  },
  {
    name: "Lamp05",
    image: Lamp05,
    isDraggable: true
  },
  {
    name: "Lamp06",
    image: Lamp06,
    isDraggable: true
  },
  {
    name: "Lamp07",
    image: Lamp07,
    isDraggable: true
  },
  {
    name: "Lamp08",
    image: Lamp08,
    isDraggable: true
  },
  {
    name: "LightBulbs",
    image: LightBulbs,
    isDraggable: true
  },
];

export const Patterns = [
  {
    name: "ConcreteBlocksTexture",
    image: ConcreteBlocksTexture,
    isDraggable: true
  },
  {
    name: "ConcreteBlockspattern",
    image: ConcreteBlockspattern,
    isDraggable: true
  },
  {
    name: "ConcreteGrasspattern",
    image: ConcreteGrasspattern,
    isDraggable: true
  },
  {
    name: "ConcreteGrasstexture",
    image: ConcreteGrasstexture,
    isDraggable: true
  },
  {
    name: "GraniteTilespattern",
    image: GraniteTilespattern,
    isDraggable: true
  },
  {
    name: "GraniteTilesTexture",
    image: GraniteTilesTexture,
    isDraggable: true
  },
  {
    name: "PortugueseStoneTexture",
    image: PortugueseStoneTexture,
    isDraggable: true
  },
  {
    name: "PortugueseStoneWhitepattern",
    image: PortugueseStoneWhitepattern,
    isDraggable: true
  },
  {
    name: "PortugueseStoneWhiteTexture",
    image: PortugueseStoneWhiteTexture,
    isDraggable: true
  },
  {
    name: "PortugueseStonepattern",
    image: PortugueseStonepattern,
    isDraggable: true
  },
  {
    name: "PortugueseStonePTexturePack",
    image: PortugueseStonePTexturePack,
    isDraggable: true
  },
  {
    name: "PortugueseStonePpattern",
    image: PortugueseStonePpattern,
    isDraggable: true
  }
];

export const People = [
  {
    name: "Girl",
    image: Girl,
    isDraggable: true
  },
  {
    name: "Boy01",
    image: Boy01,
    isDraggable: true
  },
  {
    name: "Boy02",
    image: Boy02,
    isDraggable: true
  },
  {
    name: "Boy03",
    image: Boy03,
    isDraggable: true
  },
  {
    name: "Boy04",
    image: Boy04,
    isDraggable: true
  },
  {
    name: "Boy05",
    image: Boy05,
    isDraggable: true
  },
  {
    name: "Boy06",
    image: Boy06,
    isDraggable: true
  },
  {
    name: "Cat01",
    image: Cat01,
    isDraggable: true
  },
  {
    name: "Cat02",
    image: Cat02,
    isDraggable: true
  },

  {
    name: "Couple01",
    image: Couple01,
    isDraggable: true
  },
  {
    name: "Couple02",
    image: Couple02,
    isDraggable: true
  },
  {
    name: "Couple03",
    image: Couple03,
    isDraggable: true
  },
  {
    name: "Couple04",
    image: Couple04,
    isDraggable: true
  },
  {
    name: "Couple05",
    image: Couple05,
    isDraggable: true
  },
  {
    name: "Couple06",
    image: Couple06,
    isDraggable: true
  },
  {
    name: "Couple07",
    image: Couple07,
    isDraggable: true
  },
  {
    name: "Couple08",
    image: Couple08,
    isDraggable: true
  },
  {
    name: "Couple09",
    image: Couple09,
    isDraggable: true
  },

  {
    name: "Dog01",
    image: Dog01,
    isDraggable: true
  },
  {
    name: "Dog02",
    image: Dog02,
    isDraggable: true
  },

  {
    name: "Girl01",
    image: Girl01,
    isDraggable: true
  },
  {
    name: "Girl02",
    image: Girl02,
    isDraggable: true
  },
  {
    name: "Girl03",
    image: Girl03,
    isDraggable: true
  },
  {
    name: "Girl04",
    image: Girl04,
    isDraggable: true
  },

  {
    name: "Group01",
    image: Group01,
    isDraggable: true
  },
  {
    name: "Group02",
    image: Group02,
    isDraggable: true
  },
  {
    name: "Group03",
    image: Group03,
    isDraggable: true
  },
  {
    name: "Group04",
    image: Group04,
    isDraggable: true
  },
  {
    name: "Group05",
    image: Group05,
    isDraggable: true
  },

  {
    name: "Lady01",
    image: Lady01,
    isDraggable: true
  },
  {
    name: "Lady02",
    image: Lady02,
    isDraggable: true
  },
  {
    name: "Lady03",
    image: Lady03,
    isDraggable: true
  },
  {
    name: "Lady04",
    image: Lady04,
    isDraggable: true
  },
  {
    name: "Lady05",
    image: Lady05,
    isDraggable: true
  },
  {
    name: "Lady06",
    image: Lady06,
    isDraggable: true
  },
  {
    name: "Lady07",
    image: Lady07,
    isDraggable: true
  },
  {
    name: "Lady08",
    image: Lady08,
    isDraggable: true
  },
  {
    name: "Lady09",
    image: Lady09,
    isDraggable: true
  },
  {
    name: "Lady10",
    image: Lady10,
    isDraggable: true
  },
  {
    name: "Lady11",
    image: Lady11,
    isDraggable: true
  },
  {
    name: "Lady12",
    image: Lady12,
    isDraggable: true
  },
  {
    name: "Lady13",
    image: Lady13,
    isDraggable: true
  },

  {
    name: "Man01",
    image: Man01,
    isDraggable: true
  },
  {
    name: "Man02",
    image: Man02,
    isDraggable: true
  },
  {
    name: "Man03",
    image: Man03,
    isDraggable: true
  },
  {
    name: "Man04",
    image: Man04,
    isDraggable: true
  },
  {
    name: "Man05",
    image: Man05,
    isDraggable: true
  },
  {
    name: "Man06",
    image: Man06,
    isDraggable: true
  },
  {
    name: "Man07",
    image: Man07,
    isDraggable: true
  },
  {
    name: "Man08",
    image: Man08,
    isDraggable: true
  },
  {
    name: "Man09",
    image: Man09,
    isDraggable: true
  },
  {
    name: "Man10",
    image: Man10,
    isDraggable: true
  },
  {
    name: "Man11",
    image: Man11,
    isDraggable: true
  },
  {
    name: "Man12",
    image: Man12,
    isDraggable: true
  },

  {
    name: "Music01",
    image: Music01,
    isDraggable: true
  },
  {
    name: "Music02",
    image: Music02,
    isDraggable: true
  },
  {
    name: "Music03",
    image: Music03,
    isDraggable: true
  },
  {
    name: "Music04",
    image: Music04,
    isDraggable: true
  },
  {
    name: "Music05",
    image: Music05,
    isDraggable: true
  },
  {
    name: "Music06",
    image: Music06,
    isDraggable: true
  },
  {
    name: "Music07",
    image: Music07,
    isDraggable: true
  },

  {
    name: "Parent01",
    image: Parent01,
    isDraggable: true
  },
  {
    name: "Parent02",
    image: Parent02,
    isDraggable: true
  },
  {
    name: "Parent03",
    image: Parent03,
    isDraggable: true
  }
];

export const Sports = [
  {
    name: "Chess01",
    image: Chess01,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Climbing01",
    image: Climbing01,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Fitness03",
    image: Fitness03,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Fitness04",
    image: Fitness04,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Fitness05",
    image: Fitness05,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Playground01",
    image: Playground01,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Playground02",
    image: Playground02,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Sandbox01",
    image: Sandbox01,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Swing01",
    image: Swing01,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Swing02",
    image: Swing02,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Swing03",
    image: Swing03,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Swing04",
    image: Swing04,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Swing05",
    image: Swing05,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Table01",
    image: Table01,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "DambisLogo",
    image: DambisLogo,
    isDraggable: false,
    link: "https://www.dambis.ee/en/"
  },
  {
    name: "ETEChess01",
    image: ETEChess01,
    isDraggable: true,
    logo: ETELogo
  },
  {
    name: "ETETable01",
    image: ETETable01,
    isDraggable: true,
    logo: ETELogo
  },
  {
    name: "ETETable02",
    image: ETETable02,
    isDraggable: true,
    logo: ETELogo
  },
  {
    name: "ETETable05",
    image: ETETable05,
    isDraggable: true,
    logo: ETELogo
  },
  {
    name: "ETETable06",
    image: ETETable06,
    isDraggable: true,
    logo: ETELogo
  },
  {
    name: "ETETable07",
    image: ETETable07,
    isDraggable: true,
    logo: ETELogo
  },
  {
    name: "ETELogo",
    image: ETELogo,
    isDraggable: false,
    link: "https://www.etebg.net/"
  },
  {
    name: "Fitness01",
    image: Fitness01,
    isDraggable: true,
  },
  {
    name: "Fitness07",
    image: Fitness07,
    isDraggable: true,
  },
  {
    name: "Fitness08",
    image: Fitness08,
    isDraggable: true,
  },
];

export const UrbanFurniture = [
  {
    name: "Recyclebin01",
    image: Recyclebin01,
    isDraggable: true
  },
  {
    name: "Recyclebin02",
    image: Recyclebin02,
    isDraggable: true
  },
  {
    name: "Recyclebin05",
    image: Recyclebin05,
    isDraggable: true
  },
  {
    name: "Bench01front",
    image: Bench01front,
    isDraggable: true
  },
  {
    name: "Bench01",
    image: Bench01,
    isDraggable: true
  },
  {
    name: "Bench02semi2",
    image: Bench02semi2,
    isDraggable: true
  },
  {
    name: "Bench02semi",
    image: Bench02semi,
    isDraggable: true
  },
  {
    name: "Bench02",
    image: Bench02,
    isDraggable: true
  },
  {
    name: "Bench03",
    image: Bench03,
    isDraggable: true
  },
  {
    name: "Bench04",
    image: Bench04,
    isDraggable: true
  },
  {
    name: "Bench05",
    image: Bench05,
    isDraggable: true
  },
  {
    name: "Cafe01",
    image: Cafe01,
    isDraggable: true
  },
  {
    name: "Cafe02",
    image: Cafe02,
    isDraggable: true
  },
  {
    name: "Cafe05",
    image: Cafe05,
    isDraggable: true
  },
  {
    name: "Cafe06",
    image: Cafe06,
    isDraggable: true
  },
  {
    name: "Cafe07",
    image: Cafe07,
    isDraggable: true
  },
  {
    name: "ETEBench01",
    image: ETEBench01,
    isDraggable: true
  },
  {
    name: "ETEBench02",
    image: ETEBench02,
    isDraggable: true
  },
  {
    name: "ETEBench03",
    image: ETEBench03,
    isDraggable: true
  },
  {
    name: "ETEBench04",
    image: ETEBench04,
    isDraggable: true
  },
  {
    name: "ETEBench05",
    image: ETEBench05,
    isDraggable: true
  },
  {
    name: "ETEBench06",
    image: ETEBench06,
    isDraggable: true
  },
  {
    name: "ETELiege01",
    image: ETELiege01,
    isDraggable: true
  },
  {
    name: "ETELiege02",
    image: ETELiege02,
    isDraggable: true
  },
  {
    name: "ETELiege03",
    image: ETELiege03,
    isDraggable: true
  },
  {
    name: "ETETable03",
    image: ETETable03,
    isDraggable: true
  },
  {
    name: "Recycletriset01",
    image: Recycletriset01,
    isDraggable: true
  },
  {
    name: "TartuBench01",
    image: TartuBench01,
    isDraggable: true
  },
  {
    name: "TartuBench02",
    image: TartuBench02,
    isDraggable: true
  },
  {
    name: "TartuBench03",
    image: TartuBench03,
    isDraggable: true
  },
];

export const UrbanGreenEco = [
  {
    name: "Green01",
    image: Green01,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Green02",
    image: Green02,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Green03",
    image: Green03,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Green04",
    image: Green04,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Green05",
    image: Green05,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Green06",
    image: Green06,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Green07",
    image: Green07,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Green031",
    image: Green031,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Green041",
    image: Green041,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "DambisLogo",
    image: DambisLogo,
    isDraggable: false,
    link: "https://www.dambis.ee/"
  },
  {
    name: "Flowers01",
    image: Flowers01,
    isDraggable: true
  },
  {
    name: "Grass01",
    image: Grass01,
    isDraggable: true
  },
  {
    name: "Grass02",
    image: Grass02,
    isDraggable: true
  },
  {
    name: "Grass03",
    image: Grass03,
    isDraggable: true
  },
  {
    name: "Grass04",
    image: Grass04,
    isDraggable: true
  },
  {
    name: "Grass05",
    image: Grass05,
    isDraggable: true
  },
  {
    name: "Tree01",
    image: Tree01,
    isDraggable: true
  },
  {
    name: "Tree02",
    image: Tree02,
    isDraggable: true
  },
  {
    name: "Tree03",
    image: Tree03,
    isDraggable: true
  },
  {
    name: "Tree04",
    image: Tree04,
    isDraggable: true
  },
  {
    name: "Tree06",
    image: Tree06,
    isDraggable: true
  },
  {
    name: "Tree07",
    image: Tree07,
    isDraggable: true
  },
  {
    name: "Tree08",
    image: Tree08,
    isDraggable: true
  },
  {
    name: "Tree09",
    image: Tree09,
    isDraggable: true
  },
  {
    name: "Treepot02",
    image: Treepot02,
    isDraggable: true
  },
  {
    name: "Treepot03",
    image: Treepot03,
    isDraggable: true
  },
  {
    name: "Treepot04",
    image: Treepot04,
    isDraggable: true
  },
  {
    name: "Treepot05",
    image: Treepot05,
    isDraggable: true
  },
  {
    name: "tree",
    image: tree,
    isDraggable: true
  }
];

export const EventSeat = [
  {
    name: "Recyclebin001",
    image: Recyclebin001,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Recyclebin002",
    image: Recyclebin002,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Recyclebin005",
    image: Recyclebin005,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Bench011",
    image: Bench011,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Bench012",
    image: Bench012,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Bench013",
    image: Bench013,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Bench014",
    image: Bench014,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Bench015",
    image: Bench015,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "Recycletriset011",
    image: Recycletriset011,
    isDraggable: true,
    logo: DambisLogo
  },
  {
    name: "DambisLogo",
    image: DambisLogo,
    isDraggable: false,
    link: "https://www.dambis.ee/"
  },
  {
    name: "ETEBench011",
    image: ETEBench011,
    isDraggable: true,
    logo: ETELogo
  },
  {
    name: "ETEBench012",
    image: ETEBench012,
    isDraggable: true,
    logo: ETELogo
  },
  {
    name: "ETEBench013",
    image: ETEBench013,
    isDraggable: true,
    logo: ETELogo
  },
  {
    name: "ETEBench014",
    image: ETEBench014,
    isDraggable: true,
    logo: ETELogo
  },
  {
    name: "ETEBench015",
    image: ETEBench015,
    isDraggable: true,
    logo: ETELogo
  },
  {
    name: "ETEBench016",
    image: ETEBench016,
    isDraggable: true,
    logo: ETELogo
  },
  {
    name: "ETELiege011",
    image: ETELiege011,
    isDraggable: true,
    logo: ETELogo
  },
  {
    name: "ETELiege012",
    image: ETELiege012,
    isDraggable: true,
    logo: ETELogo
  },
  {
    name: "ETELiege013",
    image: ETELiege013,
    isDraggable: true,
    logo: ETELogo
  },
  {
    name: "ETETable013",
    image: ETETable013,
    isDraggable: true,
    logo: ETELogo
  },
  {
    name: "ETELogo",
    image: ETELogo,
    isDraggable: false,
    link: "https://www.etebg.net/"
  },
  {
    name: "Bench012front",
    image: Bench012front,
    isDraggable: true
  },
  {
    name: "Bench022semi2",
    image: Bench022semi2,
    isDraggable: true
  },
  {
    name: "Bench022semi",
    image: Bench022semi,
    isDraggable: true
  },
  {
    name: "Cafe011",
    image: Cafe011,
    isDraggable: true
  },
  {
    name: "Cafe022",
    image: Cafe022,
    isDraggable: true
  },
  {
    name: "Cafe055",
    image: Cafe055,
    isDraggable: true
  },
  {
    name: "Cafe066",
    image: Cafe066,
    isDraggable: true
  },
  {
    name: "Cafe077",
    image: Cafe077,
    isDraggable: true
  },
  {
    name: "TartuBench011",
    image: TartuBench011,
    isDraggable: true
  },
  {
    name: "TartuBench022",
    image: TartuBench022,
    isDraggable: true
  },
  {
    name: "TartuBench033",
    image: TartuBench033,
    isDraggable: true
  },
]